import { ADD_COMMENT_REPLY } from 'root/src/client/logic/comment/actionIds'

export default payload => ({
	type: ADD_COMMENT_REPLY,
	payload,
})
